// src/pages/OrderSuccess.js
import React from "react";
import { Link } from "react-router-dom";
import "../../assets/css/OrderSuccess.css"; // optional CSS file

const Successfully = () => {
  return (
    <div className="order-success-container">
      <div className="order-success-card">
      <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" /><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
        <h1>Order Placed Successfully!</h1>
        <p>Thank you for your purchase. Your order has been confirmed.</p>
        <div className="order-actions">
          <Link to="/" className="btn btn-outline-dark">
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Successfully;
